import MessagingChannelPreview from './MessagingChannelPreview';

export default MessagingChannelPreview;
